import type {
  DashboardKind,
  DashboardLayoutResponse,
  DashboardPeriod,
  DashboardSortDirection,
  DashboardUser,
  DashboardUserSortKey,
  DashboardWidgetKey,
  DashboardWidgetResponse,
} from "@repo/shared/types";
import { get } from "./_client";
import { browserTimezone } from "./browser-timezone";

/** Which dashboard, and whose (a User Dashboard for another user needs admin). */
export type DashboardTarget = {
  dashboard: DashboardKind;
  forUserId?: string;
};

export type DashboardWidgetOptions = {
  period?: DashboardPeriod;
  sortBy?: DashboardUserSortKey;
  sortDir?: DashboardSortDirection;
  language: string;
};

function targetParams(target: DashboardTarget): URLSearchParams {
  const params = new URLSearchParams({ dashboard: target.dashboard, timezone: browserTimezone() });
  if (target.forUserId) params.set("forUserId", target.forUserId);
  return params;
}

export function getDashboardLayout(target: DashboardTarget) {
  return get<DashboardLayoutResponse>(`/internal/dashboard/layout?${targetParams(target)}`);
}

export function getDashboardWidget<K extends DashboardWidgetKey>(
  key: K,
  target: DashboardTarget,
  options: DashboardWidgetOptions,
) {
  const params = targetParams(target);
  params.set("language", options.language);
  if (options.period) params.set("period", options.period);
  if (options.sortBy) params.set("sortBy", options.sortBy);
  if (options.sortDir) params.set("sortDir", options.sortDir);
  return get<DashboardWidgetResponse<K>>(`/internal/dashboard/widgets/${key}?${params}`);
}

export function getDashboardUsers() {
  return get<DashboardUser[]>("/internal/dashboard/users");
}
